import React from "react"
import {
    SectionComponent,
    FluidImage as ImageType,
  } from '@codersclan/gatsby-theme-airfleet/src/@types';
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';
import { Box, Container } from "theme-ui";
import { promoBlockStyle } from "./style";
import TwoPromoBlocks from "./twopromoblocks";
import ThreePromoBlocks from "./threepromoblocks";
import Margin from "../../components/margin/margin";
import Background from "../../components/background";

export interface PromoBlockCard {
  background: ImageType
  title: string;
  link: {
    target: string;
    url: string;
  }
  excerpt: string;
  category: string;
}

export interface PromoBlockProps extends Section {
  margin: {
    desktop: {
      bottom: string;
      top: string;
    }
    mobile: {
      bottom: string;
      top: string;
    }
    tablet: {
      bottom: string;
      top: string;
    }
  }
  background: {
    backgroundSettings: {
      attachment: string;
      image: ImageType;
      mixBlendMode: string;
      repeat: string;
      size: string;
      position: {
        x: string;
        y: string;
      };
    };
  };
  cards: {
    items: PromoBlockCard[];
  };
  title: {
    value: string;
  }
}

const PromoBlock: SectionComponent<PromoBlockProps> = ({
  background,
  cards,
  margin,
  title
}) => {
  if (!cards?.items || !!!cards.items.length) return <></>

  return (
    <Margin margins={margin}>
      <Background background={background}>
        <Container sx={promoBlockStyle.container}>
          <Box as="h2" dangerouslySetInnerHTML={{ __html: title.value }} sx={promoBlockStyle.title} />

          {cards.items.length === 2 && <TwoPromoBlocks cards={cards.items} />}
          {cards.items.length >= 3 && <ThreePromoBlocks cards={cards.items} />}
        </Container>
      </Background>
    </Margin>
  );
};

export default PromoBlock;
